import React from "react";
import Banners from "../data/data.json";
import { AddButton } from "./addButton";

export const ProductPage = props => {
  
  const prodId = props.location.query.id;
  const filteredProduct = Banners.products.filter(item =>  item.id === prodId);
  console.log(prodId, Banners.products);

  const ProductLoad = filteredProduct.map((i, index) => {
    return (
      <>
        <div className="product-image"> 
          <img src={i.img} alt={i.alt}/>
        </div>
        <div className="product-name">
          <h2>{i.alt}</h2>
          <small>$ {i.price}</small>
        </div>

        <div className="product-desc">
          <h2>Description</h2>
          <p>
            Exercitation culpa sit sunt ea mollit deserunt non tempor dolor.
            Enim officia elit commodo incididunt minim et laboris. Excepteur
            excepteur adipisicing culpa fugiat velit officia aliqua anim non
            magna. Magna tempor mollit aliquip consectetur irure commodo
            consequat commodo aute veniam consequat aute incididunt.
            <br />
            <br />
          </p>
        </div>
        <div className="custom-btns"><AddButton pd={i} className="sticky-cart-btn" btnText="Add To Cart"/></div>
      </>
    );
  });
  return <div className="main custom-scroll">{ProductLoad} </div>;
};
